module.exports = __webpack_public_path__ + "img/H2-MonFAD2@2x-100.6720f6be.jpg";